var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-wrapper"},[_c('div',{staticClass:"arrow-content"},[_c('div',{staticClass:"arrow-text-slot"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }